import React from "react";

import { ErrorMessage } from "./error_message";

const OrgInput = ({ form }) => {
  return (
    <label className="mb5">
      <p className="text-black-tint-40 bold body-s mb1 mt0">Organization</p>
      <input
        name="org"
        id="js-org"
        style={{
          outlineColor: form.errors.org?.message ? "var(--red)" : "var(--blue)",
        }}
        className="fds-input body-s"
        placeholder="Enter the name of your organization"
        ref={form.register({
          required: "Please enter the name of your organization",
          validate: {},
        })}
      />
      {form.errors.org ? <ErrorMessage msg={form.errors.org.message} /> : null}
    </label>
  );
};

export { OrgInput };
